// extracted by mini-css-extract-plugin
export default {"workWithUs":"WorkWithUs_workWithUs__YdQoJ","text":"WorkWithUs_text__HLTdG","caja":"WorkWithUs_caja__DR+vh"};